import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import IndexTitle from '../../molecules/IndexTitle/IndexTitle'
import BlurView from '../../atoms/BlurView/BlurView'
import PresentationTitle from '../PresentationTitle/PresentationTitle'
import { QuizType } from '../../../../commons/EditorStatus'
import './EditorIndexProject.css'

const EditorIndexProject = ({ title, image, isSelected }) => (
  <div styleName="container">
    <BlurView>
      <div styleName="cover-view">
        <div styleName="transform-view">
          <PresentationTitle title={title} image={image} participantCount={10} />
        </div>
      </div>
    </BlurView>
    <div styleName="index-title">
      <IndexTitle type={QuizType.FIRSTPAGE.value} index={0} isSelected={isSelected} />
    </div>
  </div>
)

EditorIndexProject.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string
}

EditorIndexProject.defaultProps = {
  isSelected: false
}

export default compose(pure)(EditorIndexProject)
